/**
 * Bundle Scripts
 */

// Polyfills
import 'babel-polyfill';
import 'svgxuse';
import 'object-fit-images';

// Import Libs
import './lib/bling';

// CSS Import
import '../css/app.scss';

import './scripts/prism';

// Import Partials
import scripts from './partials/scripts';
import templates from './partials/templates';
import modules from './partials/modules';

// Vue import
// const vueMap = document.querySelector('#js-mapWidget');

// Beispiel für Lazy Loading von Chunks
/* if (vueMap) {
    import('./vue/map');
} */

const app = {
    toggleGrid() {
        const gridOverlay = document.querySelector('.o-gridOverlay');
        gridOverlay.classList.toggle('is-visible');
    },

    init() {
        scripts.init();
        templates.init();
        modules.init();

        const gridToggle = document.querySelector('.js-toggleGrid');
        if (gridToggle) {
            gridToggle.addEventListener('click', this.toggleGrid, false);
        }
    }
};

// Init App!
app.init();



// WEBPACK FOOTER //
// ./___src/assets/js/app.js